/*
 * Copyright (c) 2017 Datarista, Inc.
 */

import { Record } from 'immutable';
import { actionTypes as authActionTypes } from '../actions/authentication';
import { actionTypes as userActionTypes } from '../actions/user';

export const Account = new Record(
  {
    id: 0,
    companyName: '',
    accountTypeId: 0,
    status: 0,
    address1: '',
    address2: '',
    city: '',
    stateProvince: '',
    postcode: '',
    country: '',
    url: '',
    phone: '',
    logoUrl: '',
    creditsEnabled: '',
    setupStage: null,
    contractAutorenew: '',
    contractStartDate: '',
    contractEndDate: '',
    portalHost: '',
    createdBy: 0,
    createdOn: '',
    updatedBy: 0,
    updatedOn: '',
  },
  'Account'
);
const initialState = new Account();

export default function reducer(state = initialState, action) {
  switch (action.type) {
    // User Login or token refresh
    case authActionTypes.AUTH_LOGIN_SUCCESS:
    case authActionTypes.AUTH_REFRESH_SUCCESS:
    case authActionTypes.AUTH_CHECK_SUCCESS:
    case userActionTypes.UPLOAD_COMPANY_LOGO_SUCCESS: {
      const account = new Account(action.account);
      return account;
    }
    // User Logout
    case authActionTypes.AUTH_LOGOUT_SUCCESS: {
      return new Account();
    }
    default: {
      return state;
    }
  }
}
